import type { BusinessSetupStatus } from "./api";

export const businessSetupQueryKey = ["business-setup"] as const;

export function businessSetupTarget(setup: BusinessSetupStatus): string {
  return setup.isLive ? "/tenant" : "/tenant/setup";
}

export function isBusinessSetupRouteAllowed(
  setup: BusinessSetupStatus,
  pathname: string,
): boolean {
  if (setup.isLive) return true;
  return pathname === "/tenant/setup";
}
